export interface IStripeProduct {
  id: string;
  object: string;
  active: boolean;
  attributes: string[];
  created: number;
  defaultPrice: string;
  description: string | null;
  images: string[];
  livemode: boolean;
  marketingFeatures: string[];
  metadata: Record<string, any>;
  name: string;
  packageDimensions: any | null;
  shippable: boolean | null;
  statementDescriptor: string | null;
  taxCode: string;
  type: string;
  unitLabel: string | null;
  updated: number;
  url: string | null;
}

export interface IStripePriceValue {
  quantity: number;
  price: number;
  currency: string;
  interval: string;
  coupon: IStripeCoupon;
}

export interface IStripeCoupon {
  currency: 'usd' | 'eur';
  discountType: 'percentage' | 'amount';
  discountValue: number;
}

export interface IStripeProductStruct {
  desktopPlan: IStripePriceValue;
  remotePlan: IStripePriceValue[];
  primaryPlan: IStripePriceValue[];
}

export interface IStripePriceOptionsResponse {
  globalCoupon: IStripeCoupon | null;
  products: IStripeProductStruct;
}

export class StripeProduct implements IStripeProduct {
  id: string;
  object: string;
  active: boolean;
  attributes: string[];
  created: number;
  defaultPrice: string;
  description: string | null;
  images: string[];
  livemode: boolean;
  marketingFeatures: string[];
  metadata: Record<string, any>;
  name: string;
  packageDimensions: any | null;
  shippable: boolean | null;
  statementDescriptor: string | null;
  taxCode: string;
  type: string;
  unitLabel: string | null;
  updated: number;
  url: string | null;

  constructor(data: any) {
    this.id = data.id;
    this.object = data.object;
    this.active = data.active;
    this.attributes = data.attributes || [];
    this.created = data.created;
    this.defaultPrice = data.default_price;
    this.description = data.description;
    this.images = data.images || [];
    this.livemode = data.livemode;
    this.marketingFeatures = data.marketing_features || [];
    this.metadata = data.metadata || {};
    this.name = data.name;
    this.packageDimensions = data.package_dimensions;
    this.shippable = data.shippable;
    this.statementDescriptor = data.statement_descriptor;
    this.taxCode = data.tax_code;
    this.type = data.type;
    this.unitLabel = data.unit_label;
    this.updated = data.updated;
    this.url = data.url;
  }
}
